import theme from '@styles/theme';
import reusables from '@styles/theme/reusables';

export default {
  singleArticle: (isInterior: boolean) => ({
    position: 'relative',
    boxSizing: 'border-box',
    // WCAG 2.4.7 Focus Visible - outline na całej karcie
    '&.has-focus-visible': {
      boxShadow: `0 0 0 2px ${theme.rawColors.blue500}`,
    },
    '&:has(a:focus-visible)': {
      boxShadow: `0 0 0 2px ${theme.rawColors.blue500}`,
    },
    a: {
      display: 'block',
      '&:focus-visible': {
        outline: 'none',
      },
      '&:focus:not(:focus-visible)': {
        outline: 'none',
      },
    },
    ...reusables.mainTransition('background'),
    '&:hover': {
      bg: isInterior ? theme.rawColors.lightGrey500 : theme.rawColors.beige500,
      '.readMore': {
        opacity: 1,
      },

      '.image_hover': {
        opacity: [0, 0, 0, 1],
      },
    },
  }),
  wrapper: {
    width: '100%',
    p: ['16px 16px 32px 16px', '16px 16px 32px 16px', '24px 24px 32px 24px', '24px 24px 32px 24px', 40],
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    position: 'relative',
  },
  headingContainer: {
    minHeight: 121.58,
  },
  heading: {
    pt: '24px',
  },
  imgContainer: (isInterior: boolean) => ({
    width: '100%',
    paddingTop: '75%',
    position: 'relative',
    img: {
      objectFit: isInterior ? 'contain' : 'cover',
    },
    imageHover: {
      opacity: 0,
      ...reusables.mainTransition('opacity'),
    },
    '.image_hover': {
      objectFit: 'cover',
    },
  }),
  img: {
    width: '100%',
    height: '100%',
  },
  tag: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    pt: '8px',
    color: theme.rawColors.darkGrey700,
    fontFamily: theme.fonts.uniform,
    fontSize: theme.fontSizes.text,
    lineHeight: '140%',
    letterSpacing: theme.letterSpacings.caps,
    span: {
      pr: '8px',
    },
  },
  description: {
    mt: ['16px', '16px', '16px', '16px', '40px'],
    color: theme.rawColors.darkGrey700,
    fontFamily: theme.fonts.uniform,
    fontSize: theme.fontSizes.text,
    lineHeight: '175%',
    height: 'auto',
    display: '-webkit-box',
    WebkitLineClamp: 3,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
  },
  readMore: {
    pt: '16px',
    color: theme.rawColors.neutralBlack,
    textDecoration: 'underline',
    fontFamily: theme.fonts.uniform,
    fontSize: theme.fontSizes.smallText,
    lineHeight: '140%',
    opacity: [1, 1, 1, 0],
    textTransform: 'lowercase',
    ...reusables.mainTransition('opacity'),
  },
};
